import React from 'react';

export default function IceCream() {
	// 10
	let style = {
		st15: {
 			fill:"#FCDAC9"
		},
		st116: {
 			fill:"#F9C9B4"
		},
		st0: {
 			fill:"#FFFFFF"
		}
	};
	return (
		<g>
			<path style={style.st15} d="M97.7784424,343.6196594l-36.8149567,21.9043274L44.3048096,299.152832
				c-0.4536781-1.8075256,1.7190514-3.1002502,3.0911522-1.8391724L97.7784424,343.6196594z"/>
			<path style={style.st116} d="M44.3046875,299.152832l0.1025391,0.4084473l-0.0952148-1.3798828
				C44.2290039,298.4765625,44.2172852,298.8046875,44.3046875,299.152832z"/>
			<path style={style.st116} d="M85.4443359,343.2739258l9.1201172-0.6298828l0.1914062,2.7739258l3.0224609-1.7983398
				l-4.7617188-4.3764648l-7.8134766,0.5395508l-0.5693359-8.2441406l-4.4418945-4.0825195l-8.4726562,0.5852051
				l-0.7946777-8.9396973L67,315.657959v0.012207l-8.9421387,0.6298828l-0.5408936-9.1213379l0.531311-0.0336914l-4.2467957-3.923584
				l0.0599518,0.7075195l-8.2210007,0.5678711l0.8685036,3.447998l7.6034431-0.5249023l0.6305771,9.1213379l-5.9708443,0.4123535
				l0.8658943,3.4477539l5.3467674-0.3691406l0.6299286,9.1213379l-3.715313,0.2565918l0.8652458,3.4477539l3.0913162-0.2133789
				l0.6298828,9.1213379l-1.4599571,0.1008301l0.8652344,3.4482422l0.8359375-0.0578613l0.3227539,4.6740723l3.9135742,15.5927734
				l0.6455078-0.3840332l-0.5185547-7.5114746l9.1201172-0.6296387l0.2006836,2.9040527l3.3701172-2.0053711l-0.0786133-1.1398926
				l2.2568359-0.1557617l9.9946289-5.9467773L85.4443359,343.2739258z M58.4770508,319.7910156l9.1201172-0.6296387
				l0.6298828,9.1210938l-9.1201172,0.6298828L58.4770508,319.7910156z M59.3481445,332.4033203l9.1201172-0.6296387
				l0.6298828,9.1213379l-9.1201172,0.6298828L59.3481445,332.4033203z M60.8491211,354.1374512l-0.6298828-9.121582
				l9.1201172-0.6296387l0.6298828,9.1213379L60.8491211,354.1374512z M71.9604492,331.5324707l9.1206055-0.6298828
				l0.6298828,9.1213379l-9.1206055,0.6298828L71.9604492,331.5324707z M73.4614258,353.2663574l-0.6298828-9.1213379
				l9.1206055-0.6298828l0.6298828,9.1213379L73.4614258,353.2663574z"/>
			<path style={style.st0} d="M111.2392578,388.3376465c-3.4277344,0-4.5058594,1.8022461-4.5058594,2.7919922
				c0,0.989502,2.0175781,1.791748,4.5058594,1.791748s4.5053711-0.8022461,4.5053711-1.791748
				C115.7446289,390.1398926,114.6665039,388.3376465,111.2392578,388.3376465z"/>
			<path style={style.st0} d="M127.4794922,382.885498c0-1.5998535-1.7421875-4.5134277-7.2836914-4.5134277l0,0
				c-1.0859375-2.8686523-3.949707-5.0373535-8.262207-6.5651855c1.1865234-6.0119629,0.2529297-12.4643555-3.1274414-18.145752
				c-1.8139648-3.0488281-4.1665039-5.5742188-6.8540039-7.5541992c-0.0458984-4.0048828-4.8427734-7.480957-8.0527344-3.9875488
				c-0.0761719,0.0825195-0.1533203,0.1604004-0.2270508,0.2509766c-4.8735352,5.9558105-11.9912109,2.8269043-18.0166016,6.472168
				c-5.5600586,3.3637695-4.6513672,11.621582-12.65625,10.817627c-0.3793945-0.0380859-0.7338867-0.0361328-1.0678711-0.0036621
				c-4.6318359,0.451416-4.9140625,7.2897949-0.9248047,9.4106445c0.1728516,1.9821777,0.6000977,3.9558105,1.2446289,5.8903809
				c-1.8691406,1.2797852-2.9179688,2.6630859-2.9179688,4.0424805c0,4.9707031,13.5805664,8,30.3330078,8
				c5.7324219,0,11.3212891-0.4663086,16.1245117-1.265625c8.0834961-0.8903809,9.1445312,0.0478516,14.4047852,0.0478516
				c0.222168,0,0.4248047-0.0048828,0.6181641-0.012207C124.546875,385.6447754,127.4794922,384.4023438,127.4794922,382.885498z"/>
		</g>
	);
}



// WEBPACK FOOTER //
// ./src/components/Global/Goodies/Toy/IceCream.js